import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useThemeStore } from './system/theme'
import { useUserStore } from './system/user'
import { useBackendStore } from './system'
import { useLocaleStore } from '@/stores/system/locale.ts'

export const useInitStore = defineStore('initialization', () => {
	// State
	const initialized = ref(false)
	const isInitializing = ref(false)

	/**
	 * Ensures all stores are initialized
	 * Will only run initialization once
	 */
	async function ensureInitialized() {
		// If already initialized or in progress, return
		if (initialized.value || isInitializing.value) {
			return
		}

		isInitializing.value = true

		try {
			await initialiseStores()
			initialized.value = true
		} catch (error) {
			console.error('Store initialization error:', error)
			throw error
		} finally {
			isInitializing.value = false
		}
	}

	/**
	 * Call your existing initialization function
	 */
	async function initialiseStores() {
		// This uses your existing pattern
		await useBackendStore().initialise()
		useLocaleStore().initialise()
		await useThemeStore().initialise()
		await useUserStore().initialise()
	}

	function $reset() {
		initialized.value = false
		isInitializing.value = false
	}

	return {
		// State
		initialized,
		isInitializing,

		// Actions
		ensureInitialized,

		$reset,
	}
})
